import(/* webpackMode: "eager" */ "/app/src/app/tools/random-sample/page.tsx");
